(function () {
  var photos = [
    'https://cdn.shopify.com/s/files/1/0832/6607/6912/files/IMG_3610.jpg?v=1779778030',
    'https://cdn.shopify.com/s/files/1/0832/6607/6912/files/IMG_3613.jpg?v=1779778031'
  ];
  var gallery = document.getElementById('fm-craft-gallery');
  if (!gallery) return;

  var front = document.getElementById('fm-craft-photo-front');
  var back = document.getElementById('fm-craft-photo-back');
  var progress = document.getElementById('fm-craft-progress');
  var dots = gallery.querySelectorAll('.fm-craft-dot');
  var current = 0;
  var timer = null;

  function goTo(idx) {
    if (idx === current || !front || !back) return;
    back.querySelector('img').src = photos[idx];
    back.style.opacity = '0';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        front.style.opacity = '0';
        back.style.opacity = '1';
        setTimeout(function () {
          front.querySelector('img').src = photos[idx];
          front.style.transition = 'none';
          front.style.opacity = '1';
          back.style.transition = 'none';
          back.style.opacity = '0';
          setTimeout(function () {
            front.style.transition = 'opacity 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
            back.style.transition = 'opacity 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
          }, 50);
        }, 1150);
      });
    });
    dots[current].classList.remove('active');
    dots[current].setAttribute('aria-selected', 'false');
    current = idx;
    dots[current].classList.add('active');
    dots[current].setAttribute('aria-selected', 'true');
    restartProgress();
  }

  function next() {
    goTo((current + 1) % photos.length);
  }

  function restartProgress() {
    if (!progress) return;
    progress.style.transition = 'none';
    progress.style.width = '0%';
    clearTimeout(timer);
    void progress.offsetWidth;
    progress.classList.add('animating');
    progress.style.width = '100%';
    timer = setTimeout(next, 5000);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var idx = parseInt(dot.getAttribute('data-craft-index'), 10);
      if (!isNaN(idx)) goTo(idx);
    });
  });

  gallery.addEventListener('mouseenter', function () {
    clearTimeout(timer);
    if (progress) progress.style.transition = 'none';
  });
  gallery.addEventListener('mouseleave', restartProgress);

  if (front && back) {
    front.style.transition = 'opacity 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
    back.style.transition = 'opacity 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
    restartProgress();
  }
})();
